export default {
	'system.dept.title': '部门',
	'system.dept.dept_id': '部门id',
	'system.dept.parent_id': '父部门id',
	'system.dept.parent_dept': '上级部门',
	'system.dept.ancestors': '祖级列表',
	'system.dept.dept_name': '部门名称',
	'system.dept.order_num': '显示顺序',
	'system.dept.leader': '负责人',
	'system.dept.phone': '联系电话',
	'system.dept.email': '邮箱',
	'system.dept.status': '部门状态',
	'system.dept.del_flag': '删除标志',
	'system.dept.create_by': '创建者',
	'system.dept.create_time': '创建时间',
	'system.dept.update_by': '更新者',
	'system.dept.update_time': '更新时间',
};
